module.exports = __webpack_public_path__ + "img/outu.2012c21f.png";